<template>
  <section class="bg-white header">
    <div class="menu-header">
      <div class="header-top">
        <div class="header-left">
          <Tag type="primary"
               outline
               size="small"
               class="mr-2 menu-header-tag"
               v-if="categoryTag">
            {{ categoryTag }}
          </Tag>
          <div class="menu-id sm:mb-1 sm:w-full" v-if="menuBasicInfo && menuBasicInfo.menuNo">
            メニューNo. {{ menuBasicInfo.menuNo }}
          </div>
        </div>
        <div class="header-right">
          <Share
            :key="router"
            :facebook="false"
            :twitter="false"
            :line="false"
            :email="false"
            :social="false"
            size="large"
            :copyLabel="copyLabel"
          />
        </div>
      </div>
      <h2 class="menu-title" v-if="menuBasicInfo && menuBasicInfo.menuNm">
        <a-tooltip>
          <template slot="title">
           {{ menuBasicInfo.menuNm | capitalize }}
          </template>
          {{ menuBasicInfo.menuNm | capitalize }}
        </a-tooltip>
      </h2>
      <div class="header-meta sm:flex sm:justify-between">
        <div class="meta-item inline-flex mr-2" v-if="getAreaName">
          <i class="icon icon-bor-pin pt-1 pr-2 sm:pr-1" />
          <span class="text">
            {{getAreaName}}
          </span>
        </div>
        <button class="c-btn btn-white btn-sm map-btn-wrapper" @click="gotoMap" v-if="hasCoordinates">
          <span class="sm:hidden block">地図を見る</span>
          <span class="sm:block hidden map-btn-text">地図</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import Share from '../components/Share'

export default {
  name: 'PlanDetailHeader',
  components: {
    Share
  },
  props: ['value'],
  data() {
    return {
      idFavorite: '',
      showPopup: false,
      inWishList: false,
      menuBasicInfo: null,
      planIcons: null,
      statusFavorite: false
    }
  },
  created() {
    if (this.value) {
      this.menuBasicInfo = this.value
      this.setData()
    }
  },
  mounted() {
  },
  watch: {
    value(val) {
      this.menuBasicInfo = val
      this.setData()
    }
  },
  methods: {
    setData() {
      if (this.menuBasicInfo) {
        this.planIcons = this.menuBasicInfo.planIcons
      }
    },
    gotoMap() {
      const { latitude, longitude } = _.get(this.menuBasicInfo, 'areaInfomation', {})
      if (latitude && longitude) {
        window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
      }
    },
    copyContent() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('Copied')
    },
    copyError() {
      this.$toasted.error('Copy failed')
    }
  },
  computed: {
    hasCoordinates() {
      return _.get(this.menuBasicInfo, 'areaInfomation.latitude', null) && _.get(this.menuBasicInfo, 'areaInfomation.longitude', null)
    },
    getAreaName() {
      // areaMidClassNm > areaDtlClassNm
      if (this.menuBasicInfo && this.menuBasicInfo.areaInfomation) {
        const areaMidClassNm = this.menuBasicInfo.areaInfomation.areaMidClassNm
        const areaDtlClassNm = this.menuBasicInfo.areaInfomation.areaDtlClassNm
        return `${areaMidClassNm ? `${areaMidClassNm}` : ''}${areaMidClassNm && areaDtlClassNm ? ' > ' : ''}${areaDtlClassNm ? `${areaDtlClassNm}` : ''}`
      }
      return ''
    },
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    },
    categoryTag() {
      let categoryNm = ''
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')) {
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')
      }
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')
      }
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')
      }
      return categoryNm
    },
    copyLabel() {
      let menuNm = this.menuBasicInfo.menuNm
      let catchCopy = this.menuBasicInfo.catchCopy
      return [menuNm, catchCopy].filter(Boolean).join('\n')
    },
    router() {
      return this.$route.fullPath
    }

  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
